import React from 'react';
import { TKeyMetricsItem } from '../../kpiTypes';
import MetricsCard from '../../../../shared/components/metricsCard/MetricsCard';
import { IVesselKeyMetricsDateBased } from '../../../green/greenTypes';

export interface IKeyMetricsProps {
	keyMetricsData: TKeyMetricsItem | null;
	keyMetricsDateBased: IVesselKeyMetricsDateBased | null;
}

/**
 * KeyMetrics component displays key metrics for a vessel.
 * It uses the MetricsCard component to display various metrics in a card format.
 *
 * @param {IKeyMetricsProps} props - The props for the KeyMetrics component.
 * @param {TKeyMetricsItem | null} props.keyMetricsData - The key metrics data for the vessel.
 * @param {IVesselKeyMetricsDateBased | null} props.keyMetricsDateBased - The date-based key metrics data for the vessel.
 * @returns {JSX.Element} The rendered KeyMetrics component.
 */
const KeyMetrics: React.FC<IKeyMetricsProps> = ({ keyMetricsData, keyMetricsDateBased }) => {
	return (
		<div className="flex flex-col space-y-2 h-full w-full">
			<MetricsCard
				metrics={[
					{ label: '# Voyages', value: keyMetricsData?.voyagesCount },
					{ label: 'Total Distance (nm)', value: keyMetricsDateBased?.totalDistance },
					{ label: 'Fuel Consumed (T)', value: keyMetricsDateBased?.fuelConsumed },
					{ label: 'CO₂ Emissions (T, TtW)', value: keyMetricsDateBased?.co2Emissions },
					{ label: 'Ave Laden Speed (kn)', value: keyMetricsData?.averageLadenSpeed },
					{ label: 'Ave Laden Draft (%)', value: keyMetricsData?.averageLadenDraftPercentage },
					{ label: 'Ave Ballast Speed (kn)', value: keyMetricsData?.averageBallastSpeed },
					{ label: 'Ave Ballast Draft (%)', value: keyMetricsData?.averageBallastDraftPercentage },
					{ label: 'Ave Voyage Distance (nm)', value: keyMetricsData?.averageVoyageDistance },
					{ label: 'Ave Voyage Time (Days)', value: keyMetricsData?.averageVoyageDays },
					{ label: 'Ave Port Call Length (Days)', value: keyMetricsData?.averagePortCallsDays },
					{ label: 'Time in Shipyard', value: keyMetricsData?.totalTimeInShipyard },
				]}
				valueTextSize='text-lg'
			/>
		</div>
	);
};

export default KeyMetrics;
